import React from "react"

import i18n from "I18n"
import { getImageUrl } from "utils"
import MembershipInfoCard from "components/customer/MembershipInfoCard"
import { CampaignType, LanguageConfig } from "config/CustomEnums"
import MessageOverviewTableSection from 'components/message/MessageOverviewTableSection';

const ContentLanguageCard = ({
  campaignData,
  language,
}) => {
  const translations = campaignData?.translations
  const campaignType = campaignData?.campaignType
  const stampCampaignTypeEmptySlotStampImage = campaignData?.stampCampaignTypeEmptySlotStampImage
  const getFormDataFormTranslations = (language, valueKeys) => {
    const data = {};
    // eslint-disable-next-line no-unused-vars
    const datas = valueKeys?.forEach(valueKey => {
      switch (valueKey) {
        case 'coverPhoto':
        case 'squareCoverPhoto':
        case 'stampCampaignTypeEmptySlotStampImage':
        case 'stampCampaignTypeAcquiredStampImage':
        case 'stampCampaignTypeEmptyGiftSlotImage':
        case 'stampCampaignTypeCollectedGiftImage': {
          const url = getImageUrl(translations?.[language]?.[valueKey])
          if (!url || url === "") {
            data[valueKey] = null;
          }
          data[valueKey] = url;
          break;
        }
        case 'detailPhotos': {
          data[valueKey] = translations?.[language]?.[valueKey]?.map((item) => {
            const url = getImageUrl(item)
            if (!url || url === "") {
              return null;
            }
            return url;
          });
          break;
        }
        default: {
          data[valueKey] = translations?.[language]?.[valueKey];
        }
      }
    });
    return data;
  }
  let fields = [
    { titleTranslationKey: "name", fieldName: "generalName", },
    { titleTranslationKey: "short_description_optional", fieldName: "shortDescription", isRichText: true },
    { titleTranslationKey: "cover_photo", fieldName: "coverPhoto", },
    { titleTranslationKey: "campaign.square_cover_photo", fieldName: "squareCoverPhoto", },
    { titleTranslationKey: "other_photos", fieldName: "detailPhotos", },
    { titleTranslationKey: "instruction_section_title", fieldName: "instructionSectionTitle", },
    { titleTranslationKey: "instruction_section_content", fieldName: "instructionSectionContent", },
    { titleTranslationKey: "detail_section_title", fieldName: "detailSectionTitle", },
    { titleTranslationKey: "detail_section_content", fieldName: "detailSectionContent", },
    ...(campaignType === CampaignType.stampCampaign && stampCampaignTypeEmptySlotStampImage && language === LanguageConfig.english
      ? [
        { titleTranslationKey: "emptyStampSlot", fieldName: "stampCampaignTypeEmptySlotStampImage", },
        { titleTranslationKey: "collectedStamp", fieldName: "stampCampaignTypeAcquiredStampImage", },
        { titleTranslationKey: "emptyGiftStampSlot", fieldName: "stampCampaignTypeEmptyGiftSlotImage", },
        { titleTranslationKey: "collectedGift", fieldName: "stampCampaignTypeCollectedGiftImage", },
      ] : []
    ),
  ]
  return (
    <>
      <MembershipInfoCard
        title={i18n.t('content', { locale: 'en' })}
        data={getFormDataFormTranslations(
          language,
          [
            'generalName',
            'shortDescription',
            'coverPhoto',
            'squareCoverPhoto',
            'detailPhotos',
            'instructionSectionTitle',
            'instructionSectionContent',
            'detailSectionTitle',
            'detailSectionContent',
            'stampCampaignTypeEmptySlotStampImage',
            'stampCampaignTypeAcquiredStampImage',
            'stampCampaignTypeEmptyGiftSlotImage',
            'stampCampaignTypeCollectedGiftImage',
          ]
        )}
        fields={fields?.map((item) => [{
          title: i18n.t(item.titleTranslationKey, { locale: language }),
          field: item.fieldName,
          isRichText: item?.isRichText || false,
        }])}
      />
      <MessageOverviewTableSection message={campaignData.recurringMessage} language={language} isRecurringMessage />
    </>)
}

export default ContentLanguageCard;